import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DialogConfirmation from '@/modules/common/components/DialogConfirmation';
import { withFetch } from '~/hocs/fetch';

let abortController;

const DialogDelete = (props) => {
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleAccept = () => {
        abortController = new AbortController();

        setFetching(true);
        props.fetch.delete(`/api/files/text/${props.selectedFile.id}/`, {}, abortController)
            .then(({ok,}) => {
                if (ok) {
                    props.onOk(props.selectedFile);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        props.setSelectedFile(null);
    };

    return (
        <DialogConfirmation open={props.open} onAccept={handleAccept} onClose={handleClose} disabled={fetching}/>
    );
};

DialogDelete.propTypes = {
    selectedFile: PropTypes.object,
    setSelectedFile: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogDelete;
Component = withFetch(Component);

export default Component;
